import React from "react";
import "../../index.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useWallet } from "../../context/WalletContext";
import { useSelector } from "react-redux";

const NftCard = ({ data }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { address, isConnected, isCustodialWallet } = useWallet();
  const { user } = useSelector((state) => state);
  const isOwner = data?.owner?.address === address;
  const edition = data?.collection_type === "single" ? "Single" : "Multiple";
  const imgSrc = `https://ipfs.io/ipfs/${data?.image_hash}`;
  const checkPriceValue = data?.resale_price || data?.instant_sale_price;
  const inUSD = data?.instant_sale_price_in_usd;
  const isCollectableTab = searchParams.get("tab") === "collectable";

  const getButtonLabel = () => {
    if (isOwner || isCollectableTab) return "View";

    if (isCustodialWallet) return "Buy";

    if (!isConnected && !isCustodialWallet) return "Connect";

    return "Buy";
  };

  return (
    <div
      className="cursor-pointer bg-black rounded-2xl p-3 group/item h-fit"
      onClick={() => navigate(`/item-details/${data?.address}`)}
    >
      <div className="relative h-[26rem] lg:h-[25.25rem] z-[1] flex flex-col justify-end">
        <img
          src={imgSrc}
          className="w-full h-full rounded-xl object-cover absolute inset-0 z-[-1] lg:group-hover/item:h-[20.5rem] lg:group-hover/item:lg:h-[15.625rem] transition-all duration-300 ease-in-out"
          alt="not-found"
        />
        <div className="card-content rounded-lg bg-[#000000E5] p-2 m-2">
          <h1 className="m-0 text-xl text-white font-normal leading-[1.5] line-clamp-2">
            {data?.name}
          </h1>
          {checkPriceValue && (
            <div className="flex items-center gap-2 lg:group-hover/item:h-0 overflow-hidden transition-all duration-300 ease-in-out">
              <p className="m-0 text-yellowbuy text-2xl font-bold leading-[1.5] whitespace-nowrap">
                {data?.resale_price
                  ? data?.resale_price
                  : data?.instant_sale_price}{" "}
                BAF
              </p>
              {inUSD > 0 && (
                <p className="m-0 text-dollarColor text-base font-bold leading-[1.5] whitespace-nowrap">
                  $ {data?.instant_sale_price_in_usd}
                </p>
              )}
            </div>
          )}
          <p className="m-0 text-sm text-white !font-sans lg:h-0 lg:overflow-hidden lg:group-hover/item:h-[2rem] lg:group-hover/item:overflow-auto transition-all duration-300 ease-in-out">
            {edition}
          </p>

          <div className="flex items-center justify-between lg:h-0 lg:overflow-hidden mt-2 lg:mt-0 lg:group-hover/item:mt-[0.25rem] lg:group-hover/item:h-[2rem] lg:group-hover/item:overflow-hidden transition-all duration-300 ease-in-out">
            {checkPriceValue && (
              <p className="m-0 text-white text-2xl font-bold leading-[1.5] whitespace-nowrap min-w-0 truncate">
                {data?.resale_price
                  ? data?.resale_price
                  : data?.instant_sale_price}{" "}
                BAF
              </p>
            )}
            <button
              onClick={() => navigate(`/item-details/${data?.address}`)}
              type="button"
              className="shrink-0 whitespace-nowrap flex justify-center items-center gap-1 rounded-lg bg-yellowbuy border border-[#000000] px-4 py-1.5 text-[1rem] leading-[1] font-bold text-black"
            >
              {getButtonLabel()}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NftCard;
